<template>
    <div>
        <internal-header heading="Reports"/>
        <div>

        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-justify-center tw-gap-3">
            <div  v-for="report in reports">
                <v-btn @click="$inertia.visit(route(report.route))" class="main-btn tw-w-96">{{ report.label }}</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import AppLayout from "@/Layouts/AppLayout.vue";
    import InternalHeader from "@/Generic/InternalHeader";

    export default {
        name: "ReportsIndex",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            InternalHeader,
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                search: null,
                archiveLoading: false,
                show_activity_dialog: false,
            }
        },
        computed: {
            reports() {
                return [
                    {label:'Activity Report - Member',              route:'reports.memberactivity'},
                    {label:'Activity Report - Production',          route:'reports.activityfull'},
                    {label:'Activity Report Summary - Production',  route:'reports.activity'},
                    {label:'Availability Report',                   route:'reports.availability'},
                    {label:'Base Dues and Fees',                    route:'reports.baseduesandfees'},
                    {label:'Base Dues and Fees Line Items',         route:'reports.baseduesandfeeslineitems'},
                    {label:'Base Dues Tax Receipts',                route:'reports.baseduetaxreceipt'},
                    {label:'CRA Working Dues Report',               route:'reports.cradues'},
                    {label:'Deposit Slip',                          route:'reports.depositslips'},
                    {label:'Health & Welfare Office (AQTIS)',       route:'reports.aqtismonthly'},
                    {label:'Health & Welfare Report',               route:'reports.healthwelfare'},
                    {label:'Hybrid Tax Receipts',                   route:'reports.hybridtaxreceipt'},
                    {label:'Member Cards',                          route:'reports.membercards'},
                    {label:'Members Listing',                       route:'reports.membershiplist'},
                    {label:'Member Voluntary RRSP for EP',          route:'reports.membersupdate'},
                    {label:'Production Activity Summary',           route:'reports.productionactivitysummary'},
                    {label:'Production Report',                     route:'reports.productions'},
                    {label:'Province Discrepancies Report',         route:'reports.provincediscrepancies'},
                    {label:'RRSP Balances Outstanding',             route:'reports.rrspbalances'},
                    {label:'Statistics Audit',                      route:'reports.statisticsaudit'},
                    {label:'Trainee Report',                        route:'reports.trainee'},
                    {label:'Working Dues Tax Receipt',              route:'reports.workingdues'},
                    {label:'Yearly Working Dues Contributions',     route:'reports.yearlyworkingduescontributions'},
                ]
            },
        },
        methods: {
            methodExample() {
                return true
            },
        }
    }
</script>
